module.exports = __webpack_public_path__ + "files/ee404c0719c79d9243b3f83ce1ef5762.png";